import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { deleteIDPClientQuery } from '../apis';

const useDeleteIDPClient = () => {
  const mutationAction = useMutation({
    mutationFn: deleteIDPClientQuery,
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error delete app instance:', error);
    },
  });

  return mutationAction;
};

export default useDeleteIDPClient;
